import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

/**
 * Bloc d'un fournisseur (Fnac ou Darty) sur la page de choix de connexion.
 * Le bouton est un lien top-level vers l'URL de démarrage du SSO du fournisseur
 * (cf. ssoUtil.getSsoLoginUrl) : pas de navigation interne au routeur.
 */
const LoginBlockComponent = ({ variant, logoSrc, externalUrl, i18n }) => {
    const prefix = variant.toUpperCase();
    const title = i18n[`${prefix}_TITLE`];
    const buttonText = i18n[`${prefix}_BUTTON`];
    const text = i18n[`${prefix}_TEXT`];

    return (
        <div className={`login-block login-block-${variant}`}>
            <div className="login-block-logo">
                <div className="logo-rectangle">
                    <img src={logoSrc} alt={title} width="50" height="50" />
                </div>
            </div>

            <div className="login-block-action">
                <a className="bt bt-main" href={externalUrl} title={buttonText}>
                    {buttonText}
                </a>
            </div>

            <div className="login-block-text">
                <p>{text}</p>
            </div>
        </div>
    );
};

LoginBlockComponent.propTypes = {
    variant: PropTypes.oneOf(['fnac', 'darty']).isRequired,
    logoSrc: PropTypes.string.isRequired,
    externalUrl: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    i18n: state.i18n.page.AUTHENTICATION
});

export default connect(mapStateToProps)(LoginBlockComponent);



// WEBPACK FOOTER //
// ./src/components/pages/authentication/login-choice/LoginBlockComponent.js